import { HeliumSessionInfo } from "./types";

export const STORAGE_KEYS = {
  HELIUM_INFO: "helium-info",
} as const;

export class HeliumSessionStorage {
  private static instance: HeliumSessionStorage;

  private constructor() {
    this.initializeStorage();
  }

  private initializeStorage(): void {
    try {
      const storage = this.getStorage();
      const existing = storage.getItem(STORAGE_KEYS.HELIUM_INFO);
      if (!existing) {
        storage.setItem(
          STORAGE_KEYS.HELIUM_INFO,
          JSON.stringify({
            timestamp: Date.now(),
          }),
        );
      }
    } catch (error) {
      console.error("Error initializing storage:", error);
    }
  }

  public static getInstance(): HeliumSessionStorage {
    if (!HeliumSessionStorage.instance) {
      HeliumSessionStorage.instance = new HeliumSessionStorage();
    }
    return HeliumSessionStorage.instance;
  }

  private getStorage(): Storage {
    if (typeof window === "undefined") {
      throw new Error("Storage is only available in browser environment");
    }
    return window.sessionStorage;
  }

  public getInfo(): HeliumSessionInfo {
    try {
      const storage = this.getStorage();
      const data = storage.getItem(STORAGE_KEYS.HELIUM_INFO);
      return data ? JSON.parse(data) : {};
    } catch (error) {
      console.error("Error retrieving helium info:", error);
      return {};
    }
  }

  public updateInfo(updates: Partial<HeliumSessionInfo>): void {
    try {
      const storage = this.getStorage();
      const currentData = this.getInfo();
      const updatedData = {
        ...currentData,
        ...updates,
      };
      storage.setItem(STORAGE_KEYS.HELIUM_INFO, JSON.stringify(updatedData));
    } catch (error) {
      console.error("Error updating helium info:", error);
    }
  }

  public clearInfo(): void {
    try {
      const storage = this.getStorage();
      storage.removeItem(STORAGE_KEYS.HELIUM_INFO);
      this.initializeStorage();
    } catch (error) {
      console.error("Error clearing helium info:", error);
    }
  }
}
